import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';

interface DropdownItem {
  id: string;
  value: string;
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-dropdown',
  templateUrl:
    'console/app-js/shared/components/dropdown/dropdown.component.html'
})
export class DropdownComponent {
  @Input() data: Array<DropdownItem>;
  @Input() selection: DropdownItem;
  @Input() defaultItem: DropdownItem;
  @Input() filterable: boolean;
  @Output() valueChange = new EventEmitter();
  @Output() selectionChange = new EventEmitter();

  onUpdateValue(value: DropdownItem) {
    if (!value) {
      return;
    }
    this.selection = value;
    if (this.valueChange) {
      this.valueChange.emit(this.selection);
    }
  }

  onUpdateSelection(selection: DropdownItem) {
    if (!selection) {
      return;
    }
    this.selection = selection;
    if (this.selectionChange) {
      this.selectionChange.emit(this.selection);
    }
  }
}
